'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = withConfigSubpath;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _tree = require('../../utils/tree');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT = 'default';

function withConfigSubpath(WrappedComponent) {
  var WithConfigSubpath = function (_Component) {
    _inherits(WithConfigSubpath, _Component);

    function WithConfigSubpath(props) {
      _classCallCheck(this, WithConfigSubpath);

      var _this = _possibleConstructorReturn(this, (WithConfigSubpath.__proto__ || Object.getPrototypeOf(WithConfigSubpath)).call(this, props));

      _this.setConfigSubpath = _this.setConfigSubpath.bind(_this);
      _this.state = {
        configSubpath: props.configSubpath
      };
      return _this;
    }

    _createClass(WithConfigSubpath, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.configSubpath !== this.props.configSubpath && this.state.configSubpath !== this.props.configSubpath) {
          this.setState({
            configSubpath: this.props.configSubpath
          });
        }
      }
    }, {
      key: 'setConfigSubpath',
      value: function setConfigSubpath(configSubpath) {
        var _this2 = this;

        this.setState({
          configSubpath: configSubpath
        }, function () {
          _this2.props.didChangePage(configSubpath);

          var element = document.querySelector('.mason-' + _this2.props.config.id + '-' + configSubpath + '-0');

          if (element) {
            element.scrollIntoView();
          }
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        if (!_lodash2.default.has(this.props.config, 'data.' + this.state.configSubpath)) {
          return null;
        }

        var tree = this.props.config.data[this.state.configSubpath].tree;

        var links = _lodash2.default.filter((0, _tree.findAllNodesOfTagInTree)(tree, 'a'), function (a) {
          return _lodash2.default.startsWith(a.p.href, 'mason:');
        });

        var nextTree = _lodash2.default.reduce(links, function (result, a) {
          return (0, _tree.setPropOnNodeInTree)(result, a.path, 'onClick', function (e) {
            e.stopPropagation();
            e.preventDefault();

            _this3.setConfigSubpath(_lodash2.default.replace(a.p.href, 'mason:', ''));
          });
        }, tree);

        return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, this.props, {
          config: (0, _immutabilityHelper2.default)(this.props.config, {
            data: _defineProperty({}, this.state.configSubpath, {
              tree: {
                $set: nextTree
              }
            })
          }),
          configSubpath: this.state.configSubpath,
          setConfigSubpath: this.setConfigSubpath
        }));
      }
    }]);

    return WithConfigSubpath;
  }(_react.Component);

  WithConfigSubpath.propTypes = {
    config: _propTypes2.default.shape({
      data: _propTypes2.default.shape(_defineProperty({}, DEFAULT, _propTypes2.default.shape({
        datasources: _propTypes2.default.array,
        settings: _propTypes2.default.object,
        tree: _propTypes2.default.object
      }))),
      id: _propTypes2.default.string
    }),
    configSubpath: _propTypes2.default.string,
    didChangePage: _propTypes2.default.func
  };
  WithConfigSubpath.defaultProps = {
    config: {},
    configSubpath: DEFAULT,
    didChangePage: _lodash2.default.noop
  };
  return WithConfigSubpath;
}